import { ExerciceMediaService } from './../../service/exerciceMedia.service';
import { Student } from './../../model/student.model';
import { HttpParams } from '@angular/common/http';
import { ExerciceService } from './../../service/exercice.service';
import { Exercice } from './../../model/exercice.model';
import { ExerciceSheetService } from './../../service/exerciceSheet.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, Input, OnChanges, Output, EventEmitter, OnInit, Renderer2, ElementRef } from '@angular/core';
import { ExerciceSheet } from '../../model/exerciceSheet.model';

@Component({
  selector: 'app-sheet-view',
  templateUrl: './sheet-view.component.html',
  styleUrls: ['./sheet-view.component.scss']
})
export class SheetViewComponent implements OnInit, OnChanges {
  @Input() sheet: ExerciceSheet;
  @Input() showExercices: Boolean;
  @Input() showExamination: Boolean;
  @Input() filterByStudent: Student;
  @Output() exerciceToShow = new EventEmitter();
  @Output() examinationToShow = new EventEmitter();
  iframe_video;
  content;
  to_remember;
  student: Student;
  exercices: Exercice[];
  easyExercice: Exercice = null;
  mediumExercice: Exercice = null;
  hardExercice: Exercice = null;
  examinationExercices: Exercice[] = [];
  examinationDuration = 0;

  private audio: HTMLAudioElement | null = null;
  private currentPlayingElement: HTMLElement | null = null;

  private imagePopup: HTMLElement | null = null; // Référence à la popup en cours

  constructor(
    private exerciceMediaService: ExerciceMediaService,
    private sanitizer: DomSanitizer,
    private exerciceSheetService: ExerciceSheetService,
    private exerciceService: ExerciceService,
    private el: ElementRef,
    private renderer: Renderer2
  ) { }

  ngOnInit(): void {
    this.exerciceMediaService.getYoutubeScriptContext();
    this.setContent();
    // A décommenter pour remettre la popup d'image
    // this.createImagePopup();
  }

  setContent() {
    if (this.sheet?.content) {
      this.sheet.content = this.sheet.content.sort((a, b) => a.type_content.position - b.type_content.position);
      let tempContent = '';
      for (let i = 0; i < this.sheet.content.length; i++) {
        if (this.sheet.content[i].type_content.display_in_content) {
          tempContent += `<div class="${this.sheet.content[i].type_content.css_class}">${this.sheet.content[i].value}</div>`;
        }
      }
      this.content = this.sanitizer.bypassSecurityTrustHtml(tempContent);
      setTimeout(() => {
        this.setTtsHandle();
        // A décommenter pour remettre la popup d'image
        // this.initializeGeneratedVocabularyImages();
      }, 1000);
    }
  }

  initializeGeneratedVocabularyImages() {
    const spans = this.el.nativeElement.querySelectorAll('.generated-vocabulary-image');
  
    spans.forEach((span: HTMLElement) => {
      const imageId = span.getAttribute('data-image-id');
      if (!imageId) return; // Pas d'ID, on passe
  
      const image = this.sheet.medias.find(m => m.external_id === imageId);
      const imageUrl = image?.url;
      if (!imageUrl) return; // Pas d'image trouvée, on passe
  
      // Vérification pour éviter de binder 2 fois
      if (span.getAttribute('data-initialized') === 'true') return;
  
      // Ajout des listeners
      this.renderer.listen(span, 'mouseenter', (event) => this.showImagePopup(event, imageUrl));
      this.renderer.listen(span, 'mouseleave', () => this.hideImagePopup());
  
      // Marquer comme initialisé
      this.renderer.setAttribute(span, 'data-initialized', 'true');
    });
  }

  createImagePopup() {
    if (this.imagePopup) return; // Évite double création
    const popup = this.renderer.createElement('div');
    this.renderer.addClass(popup, 'image-popup');
    this.renderer.setStyle(popup, 'display', 'none');
    this.renderer.setStyle(popup, 'position', 'absolute');
    this.renderer.setStyle(popup, 'width', '200px');
    this.renderer.setStyle(popup, 'height', '200px');
    this.renderer.setStyle(popup, 'background-size', 'cover');
    this.renderer.setStyle(popup, 'background-position', 'center');
    this.renderer.setStyle(popup, 'border', '1px solid #ccc');
    this.renderer.setStyle(popup, 'border-radius', '4px');
    this.renderer.setStyle(popup, 'box-shadow', '0 4px 8px rgba(0,0,0,0.2)');
    this.renderer.setStyle(popup, 'z-index', '9999');
    document.body.appendChild(popup);
    this.imagePopup = popup;
  }
  
  showImagePopup(event: MouseEvent, imageUrl: string) {
    if (!this.imagePopup) {
      console.error('Popup non initialisée');
      return;
    }
    this.renderer.setStyle(this.imagePopup, 'background-image', `url('${imageUrl}')`);
    this.renderer.setStyle(this.imagePopup, 'top', `${(event.target as HTMLElement).getBoundingClientRect().bottom + window.scrollY + 5}px`);
    this.renderer.setStyle(this.imagePopup, 'left', `${(event.target as HTMLElement).getBoundingClientRect().left + window.scrollX}px`);
    this.renderer.setStyle(this.imagePopup, 'display', 'block'); // Assure affichage
    this.renderer.setStyle(this.imagePopup, 'opacity', '1'); // Optionnel
  }
  
  hideImagePopup() {
    if (this.imagePopup) {
      this.renderer.setStyle(this.imagePopup, 'display', 'none');
    }
  }
  

  ngOnChanges() {
    this.student = this.filterByStudent;
    if (this.sheet) {
      this.setContent();
      if (this.showExercices || this.showExamination) {
        this.getExercices();
      }
    }

  }

  getExaminationDuration() {
    this.examinationDuration = this.examinationExercices.map(e => e.duration).reduce((acc, value) => Number(acc) + Number(value), 0);
  }

  changeSheet(sheetId) {
    this.exerciceSheetService.getExerciceSheetById(sheetId).subscribe(sheet => {
      if (sheet) {
        this.sheet = sheet;
        this.setContent();
      }
    })
  }

  getExercices() {
    let params = new HttpParams()
    params = params.append('status', 'published');
    params = params.append('sheets', this.sheet.id.toString());
    params = params.append('salt', Math.random().toString());
    if (this.student) {
      params = params.append('is_validate_by_student', this.student.id.toString());
    }
    this.exerciceService.getExercices(params).subscribe(exercices => {
      this.exercices = exercices.results;
      if (this.showExercices) {
        this.initExercice();
      }
    })
  }

  getRandomExaminationExercices() {
    let list = this.exercices.filter(exercice => exercice.difficulty === 'hard')
    if (list.length >= 1 && list.length <= 3) {
      this.examinationExercices = list;
    }
    if (list.length > 3) {
      while (this.examinationExercices.length < 3) {
        let index = Math.floor(Math.random() * list.length);
        let exist = this.examinationExercices.filter(exercice => exercice.id === list[index].id)
        if (exist.length === 0) {
          this.examinationExercices.push(list[index])
        }
      }
    }
    this.getExaminationDuration();
  }

  initExercice() {
    this.getRandomExaminationExercices();

    let list = this.exercices.filter(exercice => exercice.difficulty === 'easy' && exercice.is_validate_by_student === false)
    if (list.length > 0) {
      this.easyExercice = list[Math.floor(Math.random() * list.length)];
    }

    list = this.exercices.filter(exercice => exercice.difficulty === 'medium' && exercice.is_validate_by_student === false)
    if (list.length > 0) {
      this.mediumExercice = list[Math.floor(Math.random() * list.length)];
    }

    list = this.exercices.filter(exercice => exercice.difficulty === 'hard' && exercice.is_validate_by_student === false)
    if (list.length > 2) {
      this.hardExercice = list[Math.floor(Math.random() * list.length)];
    }
  }

  gotoExamination() {
    this.examinationToShow.emit();
  }

  goToExercice(exercice) {
    this.emitExerciceToShow([exercice.id]);
  }

  emitExerciceToShow(exerciceList) {
    this.exerciceToShow.emit(exerciceList);
  }
  scrollToElement($element): void {
    $element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  setTtsHandle() {
    const elements = this.el.nativeElement.querySelectorAll('.tts-player');
    elements.forEach((element: HTMLElement) => {
      this.renderer.listen(element, 'click', (event) => this.handleClick(event, element));
    });
  }

  handleClick(event: Event, element: HTMLElement) {
    const id = element.getAttribute('data-tts-id');
    if (id) {
      this.playTTS(id, element);
    }
  }

  playTTS(id: string, element: HTMLElement) {
    const media = this.sheet.medias.find(m => m.external_id === id);
    if (!media) {
      console.warn(`Aucun média trouvé pour le slug: ${id}`);
      return;
    }

    if (this.audio) {
      this.audio.pause();
      this.audio.currentTime = 0;
      if (this.currentPlayingElement) {
        this.currentPlayingElement.classList.remove('playing');
      }
    }

    this.audio = new Audio(media.url);
    this.currentPlayingElement = element;

    this.currentPlayingElement.classList.add('playing');

    this.audio.play().catch((error) => console.error('Erreur de lecture TTS:', error));

    this.audio.onended = () => {
      if (this.currentPlayingElement) {
        this.currentPlayingElement.classList.remove('playing');
      }
      this.audio = null;
      this.currentPlayingElement = null;
    };
  }

}
